import { actionCreator } from 'utils';
import {
    LOAD_PARTNERS,
    SET_PARTNER_FILTER,
    SET_PARTNER_PAGINATION,
    SET_PARTNER_SORT,
    SET_EMPTY_EDITABLE_PARTNER,
    LOAD_EDITABLE_PARTNER,
    EDIT_PARTNER,
    ADD_NEW_PARTNER,
} from '../types/partnerTypes';

const initState = {
    loading: false,
    error: false,
    success: false,
    offset: 0,
    limit: 10,
    sort: null,
    listing: {},
    add: {
        loading: false,
        error: false,
        success: false,
        current: 0,
    },
    edit: {
        loading: false,
        data: null,
        error: false,
        success: false,
    },
    filters: {
        name: '',
    },
};

export default function (state = initState, action) {
    switch (action.type) {
    case LOAD_PARTNERS:
        return Object.assign({}, state, {
            loading: true,
        });

    case actionCreator(LOAD_PARTNERS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case actionCreator(LOAD_PARTNERS, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case SET_PARTNER_FILTER:
        return Object.assign({}, state, {
            loading: true,
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case SET_PARTNER_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case SET_PARTNER_SORT:
        return Object.assign({}, state, {
            sort: action.sort,
        });

    case LOAD_EDITABLE_PARTNER:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(LOAD_EDITABLE_PARTNER, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                data: action.data,
            }),
        });

    case actionCreator(LOAD_EDITABLE_PARTNER, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                error: true,
            }),
        });

    case SET_EMPTY_EDITABLE_PARTNER:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                data: null,
                error: false,
            }),
        });

    case EDIT_PARTNER:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(EDIT_PARTNER, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                success: action.success,
            }),
        });

    case actionCreator(EDIT_PARTNER, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                error: true,
            }),
        });

    case ADD_NEW_PARTNER:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(ADD_NEW_PARTNER, 'res'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: false,
                success: action.success,
            }),
        });

    case actionCreator(ADD_NEW_PARTNER, 'err'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: false,
                error: true,
            }),
        });

    default:
        return state;
    }
}
